import { validateNumber, validateFloatNumber } from 'variables/functions'

export const validateFilterbarData = (data, errors, option) => {
  if (option === 'price') {
    if (!validateNumber(data.priceMin)) {
      Object.assign(errors, { price: ' - Invalid Min Price' })
    } else if (!validateNumber(data.priceMax)) {
      Object.assign(errors, { price: ' - Invalid Min Price' })
    } else if (data.priceMin !== '' && data.priceMax !== '') {
      if (parseInt(data.priceMin) > parseInt(data.priceMax)) {
        Object.assign(errors, { price: ' - Max Price Should Not Less Than Min' })
      }
    }
    return errors
  } else if (option === 'length') {
    if (!validateFloatNumber(data.lengthMin)) {
      Object.assign(errors, { length: ' - Invalid Min Length of Shoot' })
    } else if (!validateFloatNumber(data.lengthMax)) {
      Object.assign(errors, { length: ' - Invalid Max Length of Shoot' })
    } else if (data.lengthMin !== '' && data.lengthMax !== '') {
      if (parseFloat(data.lengthMin) > parseFloat(data.lengthMax)) {
        Object.assign(errors, { length: ' - Max Length of Shoot Should Not Less Than Min' })
      }
    }
    return errors
  } else if (option === 'keyword') {
    if (!!data.keyword && data.keyword.length > 25) {
      Object.assign(errors, { keyword: ' - Keyword Cannot Exceed 25 Characters' })
    }
    return errors
  } else if (option === 'mobile') {
    if (!validateNumber(data.priceMin)) {
      Object.assign(errors, { mobile: ' - Invalid Min Price' })
    } else if (!validateNumber(data.priceMax)) {
      Object.assign(errors, { mobile: ' - Invalid Max Price' })
    } else if (
      data.priceMin !== '' &&
      data.priceMax !== '' &&
      parseInt(data.priceMin) > parseInt(data.priceMax)
    ) {
      Object.assign(errors, { price: ' - Max Price Should Not Less Than Min' })
    } else if (!validateFloatNumber(data.lengthMin)) {
      Object.assign(errors, { length: ' - Invalid Min Length' })
    } else if (!validateFloatNumber(data.lengthMax)) {
      Object.assign(errors, { length: ' - Invalid Max Length' })
    } else if (
      data.lengthMin !== '' &&
      data.lengthMax !== '' &&
      parseInt(data.lengthMin) > parseInt(data.lengthMax)
    ) {
      Object.assign(errors, { length: ' - Max Length of Shoot Should Not Less Than Min' })
    } else if (!!data.keyword && data.keyword.length > 25) {
      Object.assign(errors, { title: ' - Keyword Cannot Exceed 25 Characters' })
    }
  }
  return errors
}
